import axios from 'axios'

export default function Reader(condition, callback) {


    axios.get(condition.url)

    .then(res => {

        callback({
            data : res.data.info,
            message : res.data.message           
        })

    })
    
    .catch(err => {

        callback({
            data : null,
            message : 'ERROR'
        })
    })

}




// WEBPACK FOOTER //
// ./src/controller/Reader.js